export const PAYMENT_STATUS_FAIL = 0;
export const PAYMENT_STATUS_SUCCESS = 1;
export const PAYMENT_STATUS_UNPAID = 2;
export const PAYMENT_STATUS_PENDING = 3;

export const RENTAL_SIMPLIFIED_IDLE = 0;
export const RENTAL_SIMPLIFIED_RESERVING = 1;
export const RENTAL_SIMPLIFIED_RENTING = 2;

export const RENTAL_END = 0;
export const RENTAL_RESERVING = 1;
export const RENTAL_RIDING = 2;
export const RENTAL_PARKING = 3;
export const RENTAL_CANCEL = 4;
export const RENTAL_PAUSE = 5;

export const RENTAL_ACTION_TIMEOUT = -2;
export const RENTAL_ACTION_RESERVE = -1;
export const RENTAL_ACTION_CANCEL = 0;
export const RENTAL_ACTION_BEEP = 1;
export const RENTAL_ACTION_RIDE = 2;
export const RENTAL_ACTION_PARK = 3;
export const RENTAL_ACTION_OPEN_TRUNK = 4;
export const RENTAL_ACTION_RETURN = 5;

export const RENTAL_PAYMENT_METHOD_CREDIT_CARD = 0;
export const RENTAL_PAYMENT_METHOD_LINE_PAY = 1;
export const RENTAL_PAYMENT_METHOD_APPLE_PAY = 2;

export const REFUND_BY_MONEY = 0;
export const REFUND_BY_COUPON = 1;

export const PAYMENT_CHANNEL_TAPPAY = 0;
export const PAYMENT_CHANNEL_GOPOCKET = 1;

export const INVOICE_TYPE_GSH = 0;
export const INVOICE_TYPE_UBN = 1;
export const INVOICE_TYPE_LINKPAY = 5;

export const REFUND_ERROR_CHARGE_PROCESSING = 108;
export const REFUND_ERROR_CHARGE_DUPLICATE = 109;
export const REFUND_ERROR_INVOICE_ISSUING = 102;

export const ERROR_PAYMENT_PENDING = 301;
export const ERROR_PAYMENT_STATUS_NOT_SYNC = 302;
export const ERROR_PAYMENT_CANCEL = 303;
